export const LookupsPermissions = {
  ViewAllLookup: {
    permissionsId: '34b3dafa-ba50-40f8-72dd-08d96894ec62',
    permissionsName: 'View All Lookup',
    componentsId: null,
    components: null
  },
  ViewLookupItem:
  {
    permissionsId: '127f34a4-4b13-4ced-72de-08d96894ec62',
    permissionsName: 'View Lookup Item',
    componentsId: null,
    components: null
  },
  AddNew:
  {
    permissionsId: '2af1c38e-9507-4904-72df-08d96894ec62',
    permissionsName: 'Add New',
    componentsId: null,
    components: null
  },
  Delete:
  {
    permissionsId: 'e444a514-b63a-4cea-72e0-08d96894ec62',
    permissionsName: 'Delete',
    componentsId: null,
    components: null
  },
  UpdateLookupType: {
    components: null,
    componentsId: '266a0958-4688-43d7-60c9-08d8a616b3a7',
    permissionsId: 'af30c1ca-ed28-4a46-a21e-08d8ae5a4c4f',
    permissionsName: 'Update Lookup Type'

  }

};
